<h4>
  {{ title }}
  @if (isRequired) {
    <span class="redText"> *</span>
  }
</h4>
